import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import useFormatter from '../../common/useFormatter';
import { cn } from '../../common/utils';
import { Stat } from '../../components/stats/Stat';
import { useActualityAggregatedStats } from '../hooks/useActualityAggregatedStats';
import useActualityAggregationMetricDescriptors from '../hooks/useActualityAggregationMetricDescriptors';
import { actualityAggregatedStatsSelectedAggregatedMetric } from '../store/actuality.kpi.state';
import ActualityAggregatedStats, {
  ActualityAggregatedStatsProps,
} from './ActualityAggregatedStats';
export type ActualityAggregatedStatsTotalProps =
  ActualityAggregatedStatsProps & {};

const ActualityAggregatedStatsTotal: React.FC<
  ActualityAggregatedStatsTotalProps
> = props => {
  const { t } = useTranslation('feed');
  const formatter = useFormatter();
  const aggMetric = useRecoilValue(
    actualityAggregatedStatsSelectedAggregatedMetric,
  );
  const metricDescriptors = useActualityAggregationMetricDescriptors();
  const {
    showAll,
    setShowAll,
    shouldShowSummaryToggle,
    getTotalAvailableFields,
    fieldsToShowByCategory,
    hasCategoryStats,
  } = useActualityAggregatedStats(props);
  function onClick() {}

  const isSelected = false;
  const interval = props.data?.employeeActivityDuration
    ? formatter.formatTimespanAs24String(props.data.employeeActivityDuration)
        .fullString
    : '';
  const metricValue = _.get(props.data, aggMetric);

  const metricValueFormatted = metricDescriptors[aggMetric]?.getFormatted(
    metricValue,
  ) || {
    value: 'N/A',
    unit: 'N/A',
  };

  return (
    <Stat
      inPanelMode
      isPreview
      isSelected={isSelected}
      // titleElement={
      //   <div className={'flex w-full items-center'}>
      //     <span className={'flex-1'}>{t`Total`}</span>
      //     <span
      //       title={t(`Net Time: {{netTime}}`, {
      //         netTime: interval,
      //       })}
      //       className={'text-xxs opacity-75'}
      //     >
      //       {interval}
      //     </span>
      //   </div>
      // }
      classIcon={cn('w-9 h-9 xl:w-12 xl:h-12')}
      value={metricValueFormatted.value}
      unitOfMeasure={metricValueFormatted.unit}
      // isActionable
      onClick={onClick}
      // toggleAction={
      //   <SummaryToggle
      //     shouldShow={shouldShowSummaryToggle}
      //     showAll={showAll}
      //     count={getTotalAvailableFields()}
      //     onToggle={setShowAll}
      //   />
      // }
      subStats={
        <>
          <ActualityAggregatedStats
            data={props.data}
            // mode="summary"
            // showAll={showAll}
            // setShowAll={setShowAll}
            // summaryFields={[
            //   'analyzedCost',
            //   'analyzedDuration',
            //   'analyzedDistance',
            // ]}
          />
        </>
      }
    />
  );
};

export default ActualityAggregatedStatsTotal;
